export const CategoryType = {
  Test: "exam",
};
